import { makeStyles } from '@mui/styles'
const useStyles = makeStyles((theme) => ({
  gradientText: {
    background: 'linear-gradient(124deg, #0BBCED, #1252A5)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: '#0000',
  },
  cardWidth: {
    width: '98%',
    '@media (min-width:1024px)': {
      width: '60%',
    },
  },
  pricingBreakdown: {
    margin: '10px 0px 0px 0px',
    textTransform: 'capitalize',
  },
  pricingBreakdown_final: {
    marginTop: '10px !important',
    borderTop: '1px solid #c6c6c6',
    backgroundColor: '#F5F9FF',
    padding: 15,
  },
}))

export default useStyles
